<template>
  <div>
    <el-card v-loading="tableLoading">
      <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
      <el-row>
        <el-form :model="form" v-bind="formProps.form" :rules="{}">
          <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
            <range-date-picker @showDateTime="handleSetDateTime" />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.updateTime')">
            <el-date-picker
              type="datetimerange"
              size="small"
              range-separator="-"
              v-model="updateTimeRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.merchatNo')" prop="merchatNo">
            <el-input v-model="form.merchatNo" />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.bankNo')" prop="bankNo">
            <el-input v-model="form.bankNo" />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.account')" prop="bankNo">
            <el-input v-model="form.account" />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.withdrawalNo')" prop="withdrawalNo">
            <el-input v-model.trim="form.withdrawalNo" />
          </el-form-item>
          <el-form-item :label="$t('withdraw.label.withdrawalStatus')" prop="bankNo">
            <el-select v-model="form.withdrawalStatus">
              <el-option
                v-for="item in statusData.withdrawalStatus"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="danger" @click="handleEmpty()"
              >{{ $t('btns.empty') }}
            </el-button>
            <el-button size="mini" type="primary" @click="handleSearch()"
              >{{ $t('btns.search') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>

      <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
      <el-row>
        <div class="header-table">
          <ul class="list-table">
            <li class="li-table">
              <em class="label">
                <span>
                  {{ $t('withdraw.label.withdrawalAmountTotal') }}
                </span>
                <span>：</span>
              </em>
              <span class="value">
                {{ totalData.withdrawalAmountTotal | toThousands }}
              </span>
            </li>
            <li class="li-table">
              <em class="label">
                <span>
                  {{ $t('withdraw.label.handlingFeeTotal') }}
                </span>
                <span>：</span>
              </em>
              <span class="value">
                {{ totalData.handlingFeeTotal | toThousands }}
              </span>
            </li>
          </ul>

          <el-button
            v-if="tableList.length && permission.indexOf('export:withdrawOrder') > -1"
            @click="handleExport()"
          >
            {{ $t('btns.export') }}
          </el-button>
        </div>

        <el-table
          :data="tableList"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="showCellStyle"
          stripe
        >
          <el-table-column type="index" label="#"></el-table-column>

          <el-table-column prop="account" :label="$t('withdraw.label.account')"></el-table-column>
          <el-table-column :label="$t('withdraw.label.merchatName')" prop="createAcct" />
          <el-table-column
            :label="$t('clientmanage.table.merchantNo')"
            prop="merchatNo"
          ></el-table-column>
          <el-table-column
            prop="actualTransferAmount"
            :label="$t('withdraw.label.actualTransferAmount')"
          >
            <template slot-scope="{ row }">
              {{ row.actualTransferAmount | toThousands }}
            </template>
          </el-table-column>
          <el-table-column prop="bankName" :label="$t('withdraw.label.bankName')">
          </el-table-column>
          <el-table-column prop="bankNo" :label="$t('withdraw.label.bankNo')"> </el-table-column>
          <el-table-column prop="createTime" :label="$t('withdraw.label.createTime')">
            <template slot-scope="{ row }">
              {{ row.createTime | asDayjs }}
            </template>
          </el-table-column>
          <el-table-column
            prop="withdrawalNo"
            :label="$t('withdraw.label.withdrawalNo')"
          ></el-table-column>
          <el-table-column prop="withdrawalNo" :label="$t('withdraw.label.withdrawalStatus')">
            <template slot-scope="{ row }">
              <template v-for="item in statusData.withdrawalStatus">
                <el-tag
                  :key="item.label"
                  type="item.type"
                  v-if="item.value == row.withdrawalStatus"
                  >{{ item.label }}</el-tag
                >
                <span
                  :key="item.value"
                  v-if="item.value == row.withdrawalStatus && row.withdrawalStatus === '3'"
                  >({{ row.updateAcct }})</span
                >
              </template>
            </template>
          </el-table-column>
          <el-table-column width="200px" prop="updateTime" :label="$t('withdraw.label.updateTime')">
            <template slot-scope="{ row }">
              {{ row.updateTime | asDayjs }}
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />
    </el-card>
  </div>
</template>

<script>
import withdrawListApi from '@/api/withdrawlist';
import { debounce } from 'lodash';
import { isNumber, betweenLenNumber } from '@/utils/validate';
import { mapGetters, mapState } from 'vuex';
import RangeDatePicker from '../cuscom/range-date-picker.vue';

export default {
  name: 'merchantWithdraw',
  components: { RangeDatePicker },
  data() {
    return {
      tableLoading: false,
      formTime: [],
      updateTimeRange: '',
      form: {},
      pagination: {
        no: 1,
        size: 100
      },

      tableData: {}, // 表格数据
      totalData: {},

      showLock: false,
      curRowData: null,
      amount: '',
      qrCodeUrl: '',
      description: ''
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    }),
    ...mapGetters(['permission', 'WITHDRAW_ORDER']),
    tableList() {
      // 表格list
      return this.tableData.list || [];
    },
    btnsTime() {
      return this.$t('orders.btns');
    },
    statusData() {
      return {
        withdrawalStatus: [
          {
            value: 2,
            type: 'danger',
            label: this.$t('status.error3')
          },
          {
            value: 1,
            type: 'success',
            label: this.$t('status.success3')
          },
          {
            value: 0,
            type: 'info',
            label: this.$t('status.doing1')
          },
          {
            value: 3,
            type: 'danger',
            label: this.$t('status.error13')
          }
        ],
        orderStatus: [
          {
            value: 0,
            type: 'danger',
            label: this.$t('status.error13')
          },
          {
            value: 1,
            type: '',
            label: this.$t('status.success1')
          },
          {
            value: 2,
            type: 'info',
            label: this.$t('status.errorafter')
          },
          {
            value: 3,
            type: 'success',
            label: this.$t('status.success')
          }
        ]
      };
    }
  },
  watch: {
    WITHDRAW_ORDER(n) {
      const _n = n || {};
      this.$notify.success(this.$t('tips.tip2', { money: _n.withdrawalAmount }));
      debounce(() => {
        this._handleSearch();
        this.getTotalData();
      }, 2000)();
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.getTableData();
    this.getTotalData();
  },
  methods: {
    init() {
      this.handleSearch = debounce(() => {
        this._handleSearch();
        this.getTotalData();
      }, 300);
      this.handleEmpty();
      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form',
          inline: true,
          size: 'small'
        },
        form1: {
          ref: 'form',
          inline: true,
          size: 'small',
          rules: {
            bankNo: [
              {
                required: true,
                message: this.$t('withdrawBank.rules.bankNo.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!isNumber(value)) {
                    cb(new Error(this.$t('withdrawBank.rules.bankNo.type')));
                  } else if (!betweenLenNumber(5, 30, value)) {
                    cb(new Error(this.$t('withdrawBank.rules.bankNo.length')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        }
      };
      /* ------------------------------- status 选择数据 ------------------------------ */
    },
    formatParams() {
      const [createTimeStart, createTimeEnd] = this.formTime;
      // if (!createTimeStart || !createTimeEnd) {
      //   // 若用户点击了时间表单的清空，则重新默认选择当天数据
      //   this.$refs.datePick.handleTime("today");
      // }
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key] === 0 || this.form[key]) {
            acc[key] = this.form[key];
          }
          return acc;
        }, {}),
        createTimeStart: createTimeStart,
        createTimeEnd: createTimeEnd,
        updateTimeStart: typeof this.updateTimeRange === 'object' ? this.updateTimeRange[0] : '',
        updateTimeEnd: typeof this.updateTimeRange === 'object' ? this.updateTimeRange[1] : ''
      };
    },
    async getTableData() {
      this.tableLoading = true;
      const { data } = await withdrawListApi.getPage({
        data: this.formatParams(),
        params: this.pagination
      });
      if (data && data.code === 200) {
        this.tableData = data.data;
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
        this.$message.error(data.msg);
      }
      return 'finished';
    },
    async getTotalData() {
      const { data } = await withdrawListApi.getTotal(this.formatParams());
      if (data && data.code === 200) {
        this.totalData = data.data || {};
      } else {
        this.$message.error(data.msg);
      }
    },
    handleEmpty() {
      this.form = {
        merchatNo: '',
        agentNo: '',
        bankNo: '',
        account: '',
        withdrawalStatus: ''
      };
      this.updateTimeRange = '';
      // this.$nextTick(() => {
      //   this.$refs.datePick.handleTime("today");
      // });
    },
    async handleExport() {
      const { data } = await withdrawListApi.doExport(this.formatParams());
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    _handleSearch() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.getTableData();
        }
      });
    },
    
    handleSetDateTime(dateArr) {
      this.formTime = dateArr;
    },
    showCellStyle({ row }) {
      let color = 'black';
      if (row.withdrawalStatus === '0') {
        color = 'blue';
      } else if (row.withdrawalStatus === '1') {
        color = 'green';
      } else if (row.withdrawalStatus === '2') {
        color = 'red';
      } else {
        color = '#E546F0';
      }
      return {
        textAlign: 'center',
        color: color
      };
    },
    
  }
};
</script>

<style lang="scss" scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;

  .list-table {
    display: flex;
    list-style: none;

    li {
      display: flex;
      list-style: none;

      .label {
        font-style: normal;
      }

      .value {
        display: flex;
        list-style: none;
      }
    }

    li:nth-child(n + 2) {
      margin-left: 30px;
    }
  }

  .btn-table {
    margin-left: auto;
  }
}

table,
th,
td {
  border-collapse: collapse;
  border: 2px solid lightgray;
  text-align: center;
  font-size: 30px;
  font-weight: 400;
}
.input-box {
  .inputAmount {
    margin: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/withdraw/index.vue